import { SvgIcon, SxProps, Theme } from "@mui/material";

export default function AgentActivitySvg({ sx }: { sx?: SxProps<Theme> }) {
    return (
        <SvgIcon
            viewBox="0 0 18 18"
            sx={{
                width: 18,
                height: 18,
                fill: "none",

                ...sx,
            }}
        >
            <path
                d="M8.25 7.5C8.6625 7.5 9.01563 7.35313 9.30938 7.05937C9.60313 6.76562 9.75 6.4125 9.75 6C9.75 5.5875 9.60313 5.23438 9.30938 4.94063C9.01563 4.64688 8.6625 4.5 8.25 4.5C7.8375 4.5 7.48438 4.64688 7.19063 4.94063C6.89687 5.23438 6.75 5.5875 6.75 6C6.75 6.4125 6.89687 6.76562 7.19063 7.05937C7.48438 7.35313 7.8375 7.5 8.25 7.5ZM8.25 10.5C8.8125 10.5 9.34063 10.3813 9.83438 10.1438C10.3281 9.90625 10.7562 9.56875 11.1187 9.13125C10.6812 8.84375 10.2219 8.625 9.74063 8.475C9.25938 8.325 8.7625 8.25 8.25 8.25C7.7375 8.25 7.24063 8.325 6.75938 8.475C6.27813 8.625 5.81875 8.84375 5.38125 9.13125C5.74375 9.56875 6.17188 9.90625 6.66563 10.1438C7.15938 10.3813 7.6875 10.5 8.25 10.5ZM15.45 15.75L11.925 12.225C11.4125 12.625 10.8469 12.9375 10.2281 13.1625C9.60938 13.3875 8.95 13.5 8.25 13.5C6.575 13.5 5.15625 12.9187 3.99375 11.7563C2.83125 10.5938 2.25 9.175 2.25 7.5C2.25 5.825 2.83125 4.40625 3.99375 3.24375C5.15625 2.08125 6.575 1.5 8.25 1.5C9.925 1.5 11.3438 2.08125 12.5063 3.24375C13.6687 4.40625 14.25 5.825 14.25 7.5C14.25 8.2 14.1375 8.85938 13.9125 9.47812C13.6875 10.0969 13.375 10.6625 12.975 11.175L16.5 14.7L15.45 15.75Z"
                fill="white"
            />
        </SvgIcon>
    );
}
